import { useSyncExternalStore } from "react";

// a landscape phone: too short for the pinned, viewport-high sections
const QUERY = "(max-width: 991px) and (max-height: 500px)";

const subscribe = (callback) => {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", callback);
  return () => mq.removeEventListener("change", callback);
};

const read = () => window.matchMedia(QUERY).matches;

/** Re-renders when the screen becomes (or stops being) a landscape phone. */
export default function useShortLandscape() {
  return useSyncExternalStore(subscribe, read, () => false);
}
